<template>
  <AuthPage>
    <section id="users">
      <div class="col1">
        <Panel>
          <template v-slot:header>
            <div>
              <font-awesome-icon :icon="['fas', 'users']" />&nbsp;<span
                >Users</span
              >
            </div>
          </template>
          <template v-slot:action_buttons>
            <button class="button button-sm" @click="toggleCreateUserModal()">
              Create
            </button>
            <!--<button class="button button-dropdown m-l-sm">Export</button>-->
          </template>
          <div style="overflow:auto;">
            <table v-if="users.length > 0">
              <thead>
                <tr>
                  <th style="text-align:center;">
                    <input type="checkbox" />
                  </th>
                  <th style="text-align:center;"></th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Title</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="user in users" :key="user.id">
                  <td style="text-align:center;">
                    <input type="checkbox" />
                  </td>
                  <td style="text-align:center;">
                    <a @click.prevent="viewUserProfile(user)">View</a>
                  </td>
                  <td>{{ user.name }}</td>
                  <td>{{ user.email }}</td>
                  <td>{{ user.title }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Panel>
      </div>
    </section>
    <transition name="fade">
      <Modal v-if="showModal" @close="resetModal()">
        <CreateUserForm v-if="createUserSelected"></CreateUserForm>
        <ViewUserForm
          :user="selectedUser"
          v-if="viewUserProfileSelected"
        ></ViewUserForm>
      </Modal>
    </transition>
  </AuthPage>
</template>

<script>
import { mapState } from "vuex";
import AuthPage from "@/components/AuthPage";
import Panel from "@/components/Panel";
import Modal from "@/components/Modal";
import CreateUserForm from "@/components/CreateUserForm";
import ViewUserForm from "@/components/ViewUserForm";
export default {
  data() {
    return {
      user: {},
      showModal: false,
      createUserSelected: false,
      viewUserProfileSelected: false,
      selectedUser: null,
    };
  },
  components: {
    AuthPage,
    Panel,
    Modal,
    CreateUserForm,
    ViewUserForm,
  },
  computed: {
    ...mapState(["users"]),
  },
  methods: {
    toggleCreateUserModal() {
      this.createUserSelected = true;
      this.showModal = !this.showModal;
    },
    viewUserProfile(user) {
      this.selectedUser = user;
      this.viewUserProfileSelected = true;
      this.showModal = !this.showModal;
    },
    resetModal() {
      this.createUserSelected = false;
      this.viewUserProfileSelected = false;
      this.showModal = !this.showModal;
    },
  },
  beforeMount() {
    this.$store.dispatch("fetchUsers");
  },
};
</script>

<style lang="scss" scoped></style>
